<header class="nr-header-content clearfix">
  <div class="header-top-content clearfix">
    <div class="left-content">
      <a class="header-logo" href="#">
        <img src="assets/images/Networkrail-logo.png" alt="Network Rail Logo" />
      </a>
    </div>
    <div class="middle-content">
      <h1 class="header-title align-center"><span class="headarsmth">SMTH</span> PORTAL</h1>
    </div>
    <div class="right-content clearfix" *ngIf="userInfo">
      <span class="profile-name" >{{userInfo.name}}</span>
      <div class="profile-img">
        <img class="popup-arrow" src="assets/images/ChevronDown.svg" alt="up arrow" (click)="displayProfile = !displayProfile">
        <!-- <img class="popup-avatar" src="assets/images/Delete.png" alt="up arrow"> -->
        <span class="popup-avatar">{{userInfo.name.split(' ')[0].charAt(0).toUpperCase()}}{{userInfo.name.split(' ')[1].charAt(0).toUpperCase()}} </span>
      </div>
      <div class="right-content profile-popup" *ngIf="displayProfile" (click)="displayProfile = !displayProfile">
        <div class="profile-popup-header">
          <span class="profile-namex">{{userInfo.username}}</span>
          
        </div>
        <ul>
          <li (click)="logOut();">Log Out</li>
        </ul>
      </div>
    </div>
    
  </div>
</header>
